import { PcodeAds } from '../../../typings/pcode';
import { mapVideoCreativeOptionsValueToApi } from '../../AddCreativePage/mappers';
import {
    CreateOverlayRequestData,
    CreateVideoAdditionApiResponse,
    FetchPreviewOverlayVastRequestData,
    FetchPreviewVastResponse,
    FetchVideoDataResponse,
    OVERLAY_URL,
    VideoAdditionApiResponse
} from '../../common/requestsTypings';
import { ResourceType, SharedData } from '../../common/typings';
import { CreativeOptionsData, CreativeOptionsValue } from '../../CreativeOptions/typings';
import { CanvasApiMethodExecutor } from '../CanvasApiMethodExecutor';

export const OVERLAY_RESOURCE_TYPES = {
    [ResourceType.overlay]: 'overlay'
};

export class AddOverlayMethodExecutor extends CanvasApiMethodExecutor {
    async fetchOverlay(id: string, isPreset?: boolean, sharedData?: SharedData): Promise<VideoAdditionApiResponse> {
        const path = `${OVERLAY_URL}/${isPreset ? 'presets' : 'additions'}/${id}`;

        return await this.createRequest<VideoAdditionApiResponse>(path, {}, sharedData);
    }

    async uploadOverlayFile(type: ResourceType, file: File, sharedData?: SharedData): Promise<FetchVideoDataResponse> {
        const path = `${OVERLAY_URL}/files`;
        const queryParams = [`type=${OVERLAY_RESOURCE_TYPES[type]}`];

        const formData = new FormData();
        formData.append('file', file, file.name);

        const params = {
            method: 'POST',
            body: formData,
            headers: this.headersWithoutContentType
        };

        return await this.createRequest<FetchVideoDataResponse>(path, params, sharedData, queryParams);
    }

    async fetchPreviewVast(
        optionsValue: CreativeOptionsValue,
        bundle: { name: string },
        presetId: string,
        videoPreviewData?: PcodeAds,
        sharedData?: SharedData
    ): Promise<FetchPreviewVastResponse> {
        const requestData: FetchPreviewOverlayVastRequestData = {
            data: {
                bundle,
                elements: mapVideoCreativeOptionsValueToApi(optionsValue)
            },
            preset_id: presetId
        };

        const path = `${OVERLAY_URL}/preview`;
        const params = {
            method: 'POST',
            body: JSON.stringify(requestData)
        };

        return await this.createRequest<FetchPreviewVastResponse>(path, params, sharedData);
    }

    async createOverlay(
        creativeOptions: CreativeOptionsData,
        bundle: { name: string },
        presetId: string,
        sharedData?: SharedData
    ): Promise<CreateVideoAdditionApiResponse> {
        const requestData: CreateOverlayRequestData = {
            data: {
                bundle,
                elements: mapVideoCreativeOptionsValueToApi(creativeOptions.optionsValue, true)
            },
            preset_id: presetId,
            name: creativeOptions.name
        };

        const path = `${OVERLAY_URL}`;
        const params = {
            method: 'POST',
            body: JSON.stringify(requestData)
        };

        return await this.createRequest<CreateVideoAdditionApiResponse>(path, params, sharedData);
    }
}
